import { SurveyContext, SubmitSurveyPayload } from '@/types/survey';

const API_BASE = import.meta.env.VITE_API_URL || 'http://localhost:3000/api';

class SurveyService {
  async getContext(token: string): Promise<SurveyContext> {
    const res = await fetch(`${API_BASE}/survey/token/${token}`);
    if (!res.ok) {
      throw new Error(`Failed to load survey: ${res.status}`);
    }
    return res.json();
  }

  async submit(token: string, payload: SubmitSurveyPayload): Promise<void> {
    const res = await fetch(`${API_BASE}/survey/token/${token}/submit`, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify(payload),
    });
    if (!res.ok) {
      const data = await res.json().catch(() => ({}));
      throw new Error(
        (data as { message?: string }).message || 'Failed to submit survey',
      );
    }
  }
}

export const surveyService = new SurveyService();
export { SurveyService };
